import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getSingleDispute = (disputeId: string) => {
  return axiosPrivate.get(`/dashboard/api/v1/disputes/${disputeId}`);
};